import { Injectable } from '@angular/core';
import { sideBar, sideBar2 } from '../app/core/constants/sidebar.const';
import { findRouteShowHeaderEntry } from '../app/core/helpers/route-header.helper';
import { ReturnUrlService, urlMatchesActionableSidebarPath } from '@esqyre/rental-lib';

@Injectable({ providedIn: 'root' })
export class SidebarContextService {
  private readonly menuItems = [...sideBar, ...sideBar2];

  constructor(private readonly returnUrlService: ReturnUrlService) {}

  resolveContextUrl(currentFullUrl: string): string {
    const current = currentFullUrl || '';

    const originUrl = this.resolveSidebarOriginUrl(current);
    if (originUrl) {
      return originUrl;
    }

    const staticSubPath = findRouteShowHeaderEntry(current.split('?')[0])?.value?.sidebar?.subPath;
    if (staticSubPath) {
      return staticSubPath;
    }

    if (urlMatchesActionableSidebarPath(current, this.menuItems)) {
      return current;
    }

    return current;
  }

  private resolveSidebarOriginUrl(currentFullUrl: string): string | null {
    let current = currentFullUrl;
    const visited = new Set<string>();
    let lastActionableOrigin: string | null = null;

    while (current) {
      const normalized = this.returnUrlService.normalizeTargetPath(current);
      if (visited.has(normalized)) {
        break;
      }
      visited.add(normalized);

      const origin = this.returnUrlService.peekReturnUrlForPath(current);
      if (!origin) {
        break;
      }

      if (urlMatchesActionableSidebarPath(origin, this.menuItems)) {
        lastActionableOrigin = origin;
      }

      current = origin;
    }

    return lastActionableOrigin;
  }
}
